import React, { useMemo, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { v4 } from 'uuid';

import { globalTheme as GlobalColors } from '@playbookux/playbook-web-core';
import TableHeader from './table-header';
import TableCell from './table-cell';

import {
  ButtonToggle,
  Container,
  ContainerHeader,
  ContainerTable,
  Table,
  TableCellColored,
} from './styles';

const Matrix = (props) => {
  const {
    analyticsCardSort,
  } = props;

  const [isCountType, setIsCountType] = useState(true);

  const categories = useMemo(() => _.chain(analyticsCardSort)
    .map((x) => ({
      ...x.cardSortCategory,
      isMerged: !!x.cardSortMergedCategory,
    }))
    .keyBy((x) => x.id)
    .orderBy((x) => x.id)
    .value(), [analyticsCardSort]);

  const items = useMemo(() => {
    const cleanedItems = _.chain(analyticsCardSort)
      .keyBy((x) => x.cardSortItem.id)
      .map((x) => ({ ...x.cardSortItem }))
      .orderBy((x) => x.name)
      .value();

    const mappedItems = cleanedItems.map((item) => {
      const itemCategories = categories.map((category) => {
        const categoryArr = analyticsCardSort.filter((y) => y.cardSortCategory.id === category.id && y.cardSortItem.id === item.id);
        return ({
          id: v4(),
          frequencyTotal: categoryArr[0] ? categoryArr[0].frequencyTotal : 0,
          frequencyPercentage: categoryArr[0] ? categoryArr[0].frequencyPercentage : 0,
        });
      });

      return ({
        ...item,
        itemCategories,
      });
    });

    return mappedItems;
  }, [categories, analyticsCardSort]);

  const cellColor = (frequency) => {
    const percentage = frequency * 100;
    if (percentage <= 9) return GlobalColors.color.cellColorFirstStage;
    if (percentage <= 20) return GlobalColors.color.cellColorSecondStage;
    if (percentage <= 40) return GlobalColors.color.cellColorThirdStage;
    if (percentage <= 60) return GlobalColors.color.cellColorFourthStage;
    if (percentage <= 80) return GlobalColors.color.cellColorFifthStage;
    return GlobalColors.color.cellColorSixthStage;
  };

  return (
    <Container>
      <ContainerHeader>
        <ButtonToggle.Group basic>
          <ButtonToggle
            toggle
            active={isCountType}
            onClick={() => setIsCountType(true)}
          >
            Count #
          </ButtonToggle>
          <ButtonToggle
            toggle
            active={!isCountType}
            onClick={() => setIsCountType(false)}
          >
            Percentage %
          </ButtonToggle>
        </ButtonToggle.Group>
      </ContainerHeader>

      <ContainerTable>
        <Table basic="very" celled fixed singleLine>
          <Table.Header>
            <Table.Row>
              <TableHeader
                isMerged={false}
                name="Card Name"
                isDefault
              />
              {_.map(categories, (category) => (
                <TableHeader
                  key={category.id}
                  isMerged={category.isMerged}
                  name={category.name}
                />
              ))}
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {_.map(items, (card) => (
              <Table.Row key={card.id}>
                <TableCell
                  name={card.name}
                />
                {_.map(card.itemCategories, (category) => {
                  const color = cellColor(category.frequencyPercentage);
                  return (
                    <TableCellColored key={category.id} textAlign="center" color={color}>
                      {isCountType ? category.frequencyTotal : Math.round(category.frequencyPercentage * 100)}
                    </TableCellColored>
                  );
                })}
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </ContainerTable>

    </Container>
  );
};

Matrix.propTypes = {
  analyticsCardSort: PropTypes.arrayOf(PropTypes.shape({
    cardSortCategories: PropTypes.object,
    cardSortItems: PropTypes.object,
    frequencyPercentage: PropTypes.number,
    frequencyTotal: PropTypes.number,
  })).isRequired,
};

export default Matrix;
